import { FC, Dispatch, ReactNode, SetStateAction, useContext, createContext } from "react";
import { SegmentCountType } from "src/constants/filters";
import { SearchFormInputs, SorterType, JourneyFilterType } from "src/Modules/Flights/constants";

type JourneyListingContextType = {
  searchObject: SearchFormInputs;
  filtersState: [JourneyFilterType, Dispatch<SetStateAction<JourneyFilterType>>];
  sorterState: [SorterType, Dispatch<SetStateAction<SorterType>>];
  dataCount: SegmentCountType;
  isFetching: boolean;
};
const JourneyListingContext = createContext<JourneyListingContextType | null>(null);

const TicketsListingProvider: FC<{ children: ReactNode; value: JourneyListingContextType }> = ({ children, value }) => {
  return <JourneyListingContext.Provider value={value}>{children}</JourneyListingContext.Provider>;
};

export default TicketsListingProvider;

export const useJourneyListingContext = () => {
  const context = useContext(JourneyListingContext);
  if (!context) throw new Error("Invalid usage outside of context");
  return context;
};
